<script>
import Panorama from '@components/panorama.vue'
import axios from 'axios'
import moment from "moment"
import { dragscroll } from 'vue-dragscroll'
import {authComputed} from "@state/helpers";

export default {
  components: { Panorama },
  directives: {
    dragscroll,
  },
  props: {
    camera: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      numberOfPresets: null,
      imagesRow1: null,
      imagesRow2: null,
      imagesRow3: null,
      refreshDate: null,
      polling: null,
      selectedPreset:null,
      tour:null
    }
  },
  computed: {
    ...authComputed
  },
  mounted() {
    this.requestPanoramaData()
    this.polling = setInterval(this.requestPanoramaData, 10000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    onSelectPreset(preset) {
      this.selectedPreset = preset;
      this.$emit('selectedPreset', this.selectedPreset);
    },
    requestPanoramaData() {
      Promise.all([
        axios.get(`/data/api/panorama/${this.camera.uuid}/current`, {headers: {Authorization: `Bearer ${this.currentUser.jwt}`}}),
        axios.get(`/configuration/jwt-api/systems/${this.camera.uuid}/tour`, {headers: {Authorization: `Bearer ${this.currentUser.jwt}`}})
      ]).then(([panoramaResponse, tourResponse]) => {
        this.tour = tourResponse.data;
        this.numberOfPresets = panoramaResponse.data.length;
        const rowLength = this.numberOfPresets / 3;
        if (this.imagesRow1 == null) {
          this.imagesRow1 = panoramaResponse.data.slice(0, rowLength).reverse();
          this.imagesRow2 = panoramaResponse.data.slice(rowLength, rowLength * 2).reverse();
          this.imagesRow3 = panoramaResponse.data.slice(rowLength * 2, rowLength * 3).reverse();
        } else {
          const niw1 = panoramaResponse.data.slice(0, rowLength).reverse();
          this.imagesRow1 = this.imagesRow1.map((im1, index) => im1.timestamp === niw1[index].timestamp ? im1 : niw1[index]);
          const niw2 = panoramaResponse.data.slice(rowLength, rowLength * 2).reverse();
          this.imagesRow2 = this.imagesRow2.map((im1, index) => im1.timestamp === niw2[index].timestamp ? im1 : niw2[index]);
          const niw3 = panoramaResponse.data.slice(rowLength * 2, rowLength * 3).reverse();
          this.imagesRow3 = this.imagesRow3.map((im1, index) => im1.timestamp === niw3[index].timestamp ? im1 : niw3[index]);
        }
        this.$emit('latestTempTime', Math.max(...(panoramaResponse.data.map(t => new Date(`${t.timestamp}+00:00`)))));
      }).catch((err) => {
        console.error(err);

        this.$emit('latestTempTime', 0);
      })
    },
    localRefreshDate() {
      const utc = moment.utc(this.refreshDate).toDate();

      return moment(utc).local().format('MMMM D, YYYY, HH:mm');
    },
    openModal: function () {
      this.$modal.show('panorama');
    }
  }
}
</script>

<template>
  <div :class="$style.cameraPanorama">
    <header :class="$style.header">
      <div :class="$style.headerLeft">
        <BaseCircle size="large"
          ><svg width="24" height="24" viewBox="0 0 26 19" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18.093 17.129h6v-15h-6v15zm-16 0h6v-15h-6v15zm8 0h6v-15h-6v15zM25.15 0H.851C.38 0 0 .605 0 1.349v16.302C0 18.395.381 19 .85 19h24.3c.469 0 .85-.605.85-1.349V1.349C26 .605 25.619 0 25.15 0z" fill="currentColor" fill-rule="evenodd"/></svg></BaseCircle>
      </div>
      <div :class="$style.headerRight">
        <h2>Panorama view</h2>
        <ul>
          <li v-if="numberOfPresets">
            <svg width="24" height="24" viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="currentColor" fill-rule="evenodd"><path d="M1.367 16.36h12.381V6.27H1.367v10.09zM14.432 4.903H.683A.683.683 0 000 5.586v11.458c0 .377.306.683.683.683h13.749a.683.683 0 00.683-.683V5.586a.683.683 0 00-.683-.683z"/><path d="M4.037 14.181h7.041V8.94H4.037v5.241zm-.269.537h7.579c.149 0 .268-.12.268-.268V8.67a.268.268 0 00-.268-.268H3.768a.269.269 0 00-.268.268v5.779c0 .148.12.268.268.268zM2.093 2.976h10.932a.311.311 0 100-.623H2.093a.311.311 0 000 .623M4.04.52h7.037a.26.26 0 100-.52H4.04a.26.26 0 000 .52"/></g></svg>number of
            presets : {{ numberOfPresets }}
          </li>

        </ul>
      </div>
    </header>
    <div :class="$style.container">
      <div :class="$style.content">
        <div :class="$style.content.row">
          <Panorama v-for="img in imagesRow1" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)" :class="[img.preset === selectedPreset ? $style.selected : '']" @click="onSelectPreset(img.preset)"></Panorama>
        </div>
        <div :class="$style.content.row">
          <Panorama v-for="img in imagesRow2" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)" :class="[img.preset === selectedPreset ? $style.selected : '']" @click="onSelectPreset(img.preset)"></Panorama>
        </div>
        <div :class="$style.content.row">
          <Panorama v-for="img in imagesRow3" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)" :class="[img.preset === selectedPreset ? $style.selected : '']" @click="onSelectPreset(img.preset)"></Panorama>
        </div>
        <div :class="$style.zoom" @click="openModal"><svg width="24" height="24" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.274 10.6a.796.796 0 011.124 1.124L2.715 17.41h3.749a.795.795 0 110 1.59H.796a.792.792 0 01-.545-.221c-.005-.005-.012-.006-.018-.011A.831.831 0 010 18.205v-5.666a.796.796 0 011.591 0v3.745zM18.204 0l.012.002c.1.002.198.021.292.06a.8.8 0 01.234.154l.025.017.006.01c.07.071.127.155.166.248.036.088.051.18.055.273 0 .011.006.02.006.031v5.666a.795.795 0 11-1.591 0V2.716l-5.681 5.685a.793.793 0 11-1.125-1.124l5.683-5.687h-3.75a.795.795 0 110-1.59h5.668z" fill="currentColor"/></svg></div>
      </div>
      <footer v-if="refreshDate" :class="$style.footer">Snapshots created on: {{ localRefreshDate() }}</footer>
    </div>
    <modal :class="$style.panoramaModal" name="panorama" width="95%" height="auto">
      <div slot="top-right">
        <div :class="$style.panoramaModalClose" @click="$modal.hide('panorama')">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="currentColor"><path d="M8.992 15.56a.999.999 0 01-.707-1.707l5.568-5.568a.999.999 0 111.414 1.414L9.7 15.267a.997.997 0 01-.707.293"/><path d="M14.561 15.56a.997.997 0 01-.707-.293L8.286 9.699A.999.999 0 119.7 8.285l5.568 5.568a.999.999 0 01-.707 1.707"/><path d="M11.776 2a9.719 9.719 0 00-6.913 2.862A9.716 9.716 0 002 11.776c0 2.613 1.016 5.068 2.862 6.914s4.301 2.862 6.912 2.862a9.72 9.72 0 006.916-2.864c3.811-3.811 3.811-10.014-.001-13.826A9.719 9.719 0 0011.776 2m-.002 21.552a11.697 11.697 0 01-8.326-3.448A11.69 11.69 0 010 11.776C0 8.63 1.225 5.672 3.45 3.448 5.673 1.225 8.63 0 11.776 0s6.104 1.225 8.327 3.448c4.59 4.592 4.591 12.063.001 16.655a11.706 11.706 0 01-8.33 3.449"/></g></svg>
        </div>
      </div>

      <div :class="$style.panoramaModalImage" v-dragscroll>
        <div :class="$style.content" style="min-height: 297px">
          <div :class="$style.content.row" :style="{ 'min-width': `${this.numberOfPresets * 44}px` }">
            <Panorama v-for="img in imagesRow1" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)"></Panorama>
          </div>
          <div :class="$style.content.row" :style="{ 'min-width': `${this.numberOfPresets * 44}px` }">
            <Panorama v-for="img in imagesRow2" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)"></Panorama>
          </div>
          <div :class="$style.content.row" :style="{ 'min-width': `${this.numberOfPresets * 44}px` }">
            <Panorama v-for="img in imagesRow3" :key="img.image" :camera="camera" :image="img.image" :in-tour="tour.includes(img.preset)"></Panorama>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.selected {
  margin: -3px;
  border: $color-primary 3px solid;
  z-index: 1;
}

.cameraPanorama {
  padding: 33px 18px;
  margin-bottom: 16px;
  background: $color-white;

  @media (min-width: $breakpoint-md) {
    padding: 78px 78px 55px 78px;
  }

  .header {
    display: flex;
    margin-bottom: 36px;

    .headerRight {
      margin: 13px 0 0 13px;

      @media (min-width: $breakpoint-md) {
        margin: 10px 0 0 24px;
      }

      h2 {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        letter-spacing: -0.79px;

        @media (min-width: $breakpoint-md) {
          font-size: 24px;
        }
      }

      ul {
        padding: 0;
        margin: 0;
        font-size: 13px;
        color: transparentize($color-text, 0.45);
        letter-spacing: -0.09px;
        list-style: none;

        li {
          display: flex;
          align-items: center;
          margin-top: 16px;

          svg {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            color: $color-text;
          }
        }
      }
    }
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 236px;
    background: $color-gray;

    @media (min-width: $breakpoint-md) {
      margin: 0 -78px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: start;
    max-width: 100%;

    div{
      display: flex;
      flex-direction: row;
    }


    .zoom {
      //position: absolute;
      //right: 0;
      //bottom: 0;
      align-self: flex-end;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45px;
      height: 39px;
      cursor: pointer;
      border: 1px solid transparentize($color-white, 0.79);
      border-right: 0;
      border-bottom: 0;
      border-top-left-radius: 35px;

      &:hover {
        background: transparentize($color-white, 0.79);
      }

      svg {
        width: 19px;
        height: 19px;
        margin-left: 8px;
        color: $color-white;
      }
    }
  }

  .footer {
    margin: 10px 0 0 0;
    font-size: 13px;
    color: transparentize($color-text, 0.45);
    letter-spacing: -0.09px;

    @media (min-width: $breakpoint-md) {
      margin: 10px 0 0 76px;
    }
  }

  .panoramaModal {
    .panoramaModalImage {
      position: relative;
      overflow-x: auto;
      overflow-y: hidden;
      background: $color-gray;
    }

    .panoramaModalClose {
      margin: 10px 10px 0 0;
      color: $color-primary;
      cursor: pointer;

      svg {
        width: 30px;
        height: 30px;
      }

      &:hover {
        svg {
          color: darken($color-primary, 10%);
        }
      }
    }
  }
}
</style>
